/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint react/jsx-no-bind:0 react/no-this-in-sfc:0 */
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.

import { DSTextBox } from '@elliemae/ds-legacy-form';
import { Grid } from '@elliemae/ds-grid';
import { __UNSAFE_SPACE_TO_DIMSUM, op, withTheme } from '@elliemae/ds-system';
import { noop } from 'lodash-es';
import React, { useEffect, useState } from 'react';
import { DSMobileTouchable } from '../MobileTouchable/index.js';
import { Footer, HeaderContainer, ListContainer, StyledContainer, checkbox, checked, selectedMark } from './styled.js';

const MobileSelectList = ({
  open = false,
  header = null,
  multiple = false,
  onChange = noop,
  children,
  theme,
  zIndex = 1,
  useSearch,
  onSearch = noop,
  dataTestid = 'mobile-select-list',
  buttonFooter = null,
  ButtonFooter,
  onApply = noop,
  selecteds: initSelecteds = [],
}) => {
  const rows = ['auto', 1];
  const [selecteds, setSelected] = useState(initSelecteds);
  const [filter, setFilter] = useState('');
  useEffect(() => {
    setSelected(initSelecteds);
  }, [initSelecteds]);

  const handleSelection = (value) => {
    if (multiple) {
      const index = selecteds.findIndex((s) => s === value);
      if (index > -1) setSelected(selecteds.filter((s) => s !== value));
      else setSelected([...selecteds, value]);
    } else setSelected([value]);
  };
  const handleChange = function (event) {
    onChange(event, this);
    handleSelection(this.value);
  };
  const handleOnSearch = (e) => {
    setFilter(e.target.value);
    onSearch(e);
  };

  const handleApply = function (e) {
    if (this.onClick) this.onClick(e);
    onApply(e, selecteds);
  };
  if (buttonFooter || ButtonFooter) rows.push(op('*', __UNSAFE_SPACE_TO_DIMSUM(theme.space.xl), 1.16666));
  if (!open) return null;
  return (
    <StyledContainer data-testid={dataTestid} rows={rows} zIndex={zIndex}>
      <HeaderContainer>
        {header}
        {useSearch && (
          <Grid
            alignItems="center"
            height={__UNSAFE_SPACE_TO_DIMSUM(theme.space.xl)}
            pl={__UNSAFE_SPACE_TO_DIMSUM(theme.space.s)}
            pr={__UNSAFE_SPACE_TO_DIMSUM(theme.space.s)}
          >
            <DSTextBox onChange={handleOnSearch} placeholder="Filter by name" value={filter} />
          </Grid>
        )}
      </HeaderContainer>
      <Grid style={{ overflow: 'hidden' }}>
        <Grid style={{ overflow: 'auto' }}>
          <ListContainer data-testid={`${dataTestid}--list-container`}>
            {React.Children.map(children, (child) => {
              let leftAddon = null;
              let rightAddon = null;
              const { value, title } = child.props;
              const found = selecteds.findIndex((s) => String(s) === String(value));
              if (
                filter &&
                !String(value).toLocaleLowerCase().includes(filter.toLocaleLowerCase()) &&
                !String(title).toLocaleLowerCase().includes(filter.toLocaleLowerCase())
              )
                return null;
              if (multiple) {
                if (found > -1) leftAddon = checked;
                else leftAddon = checkbox;
              } else if (found > -1) {
                rightAddon = selectedMark;
              }
              return (
                <DSMobileTouchable onClick={handleChange.bind(child.props)}>
                  {React.cloneElement(child, { leftAddon, rightAddon })}
                </DSMobileTouchable>
              );
            })}
          </ListContainer>
        </Grid>
      </Grid>
      {ButtonFooter || Boolean(buttonFooter) ? (
        <Footer
          alignItems="center"
          // eslint-disable-next-line max-lines
          pl={__UNSAFE_SPACE_TO_DIMSUM(theme.space.s)}
          pr={__UNSAFE_SPACE_TO_DIMSUM(theme.space.s)}
        >
          {!ButtonFooter ? (
            React.cloneElement(buttonFooter, {
              ...buttonFooter.props,
              containerProps: {
                'data-testid': `${dataTestid}--btn`,
              },
              buttonType: 'primary',
              size: 'l',
              onClick: handleApply.bind(buttonFooter.props),
            })
          ) : (
            <ButtonFooter
              containerProps={{
                'data-testid': `${dataTestid}--btn`,
              }}
              buttonType="primary"
              size="l"
              onClick={handleApply}
            />
          )}
        </Footer>
      ) : null}
    </StyledContainer>
  );
};

const DSMobileSelectList = withTheme(MobileSelectList);

export { DSMobileSelectList };
